<template>
    <div class="mainFooter">
      <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2021002739号-4</a>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped lang="scss">
.mainFooter{
    background-color: #e8e8e8;
    height: 30px;
  line-height: 30px;
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 0;
    z-index: 1;
  a{
    color: #bbb;
    font-size: 12px;
  }
  a:hover{
    color: #222;
  }
}
</style>
